import styled from "@emotion/styled";
import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useRef } from "react";
import { AllImage, IconStyle, Liststyling } from "../styling/style";
import XIcon from '../assets/x-icon.png';
import Telegram from '../assets/telegram.png';
import EndLogo from '../assets/end-logo.png';
import { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";

const Div = styled.div`
    background: linear-gradient( to top, #FE8D46, #EE5867 );
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    /* margin-top: 10%; */
`
const EndP = styled(Typography)`
    color: #ffffff;
    max-width: 250px;
    font-size: 12px;
    font-family: poppins-regular;
    padding: 10px 0px 30px;
    @media (max-width: 600px){
       padding: ${props=>props.pds? props.pds : ''};
    }
`
const EndLink = styled.a`
    color: #ffffff;
    max-width: 350px;
    font-size: 12px;
    font-family: poppins-regular;
    text-decoration: none;
`
const SocialGrid = styled(Grid)`
    @media (max-width: 600px){
       padding: 0 0 0 67%;
    }
`
const End = () => {
    useEffect(() => {
        AOS.init({
          duration: 800,
          offset: 200,
        });
      }, []);
    
      useEffect(() => {
        AOS.refresh();
      });
    return(
        <Div>
        <Container maxWidth = 'lg'>
            <Grid container sx={{padding: '50px 0px 20px', display: 'flex', justifyContent: 'space-between', margin: 'auto'}} data-aos='fade-in' data-aos-duration="1500">
                <Grid xs={6} sm={6} md={8} >
                    <AllImage maxw = '200px' src={EndLogo}/>
                    <EndP>Your Smart Companion for Margin Trading in Cryptocurrencies</EndP>
                    <EndP pds ='20% 0 0 0'>@2023 Peachy Traders</EndP>
                </Grid>
                <Grid xs={4} sm={3} md={2} lg={3}>
                    <Typography sx={{color: '#ffffff', fontFamily: 'poppins-semibold', padding:'10px 0px 0px'}}>Quick links</Typography>
                    <Liststyling pd='2px'><EndLink href="/" >Home</EndLink></Liststyling>
                    <Liststyling pd='2px'><EndLink href="#about">About</EndLink></Liststyling>
                    <Liststyling pd='2px'><EndLink href="#features">Features</EndLink></Liststyling>
                    <Liststyling pd='2px'><EndLink href="">$PEACHY</EndLink></Liststyling>
                    {/* <Liststyling pd='2px'><EndLink href="">Whitepaper</EndLink></Liststyling> */}
                </Grid>
                <SocialGrid xs={12} sm={3} md={2} lg={1}>
                    <Typography sx={{color: '#ffffff', fontFamily: 'poppins-semibold', padding: '10px 0px 0px'}}>Socials</Typography>
                    <Box sx={{padding: '20px 0px'}}>
                        <IconStyle  p='10px 8px 4px' href="https://twitter.com/peachy_trader"><AllImage maxw='20px' src={XIcon}/></IconStyle>
                        <IconStyle p='10px 8px 4px' href="https://t.me/peachy_trader"><AllImage maxw='20px' src={Telegram}/></IconStyle>
                    </Box>
                </SocialGrid>
            </Grid>
        </Container>
        </Div>
    )
}

export default End;